import { isDevMode } from '@angular/core';
import type { TranslocoConfig } from '@jsverse/transloco';

import {
  WORKFORCE_DEFAULT_LANG,
  WORKFORCE_FALLBACK_LANG,
  WORKFORCE_LANGS,
} from './i18n/workforce-langs';

export const translocoConfig: TranslocoConfig = {
  availableLangs: [...WORKFORCE_LANGS],
  defaultLang: WORKFORCE_DEFAULT_LANG,
  fallbackLang: WORKFORCE_FALLBACK_LANG,
  reRenderOnLangChange: true,
  prodMode: !isDevMode(),
  failedRetries: 2,
  missingHandler: {
    allowEmpty: false,
    useFallbackTranslation: true,
    logMissingKey: isDevMode(),
  },
  flatten: {
    aot: false,
  },
  interpolation: ['{{', '}}'],
  scopes: {
    keepCasing: false,
  },
};
